import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/icons/close.svg'


const _hoisted_1 = {
  key: 0,
  class: "page-wr"
}
const _hoisted_2 = { class: "title-main" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "default-form" }
const _hoisted_5 = { class: "input-row" }
const _hoisted_6 = { class: "input-wr" }
const _hoisted_7 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_8 = { class: "input-wr" }
const _hoisted_9 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_10 = { class: "input-row" }
const _hoisted_11 = { class: "input-wr right" }
const _hoisted_12 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_13 = { class: "input-wr" }
const _hoisted_14 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_15 = { class: "input-row add-projects-wrapper" }
const _hoisted_16 = { class: "actions-wrapper" }
const _hoisted_17 = { class: "cancel-btn-wrapper" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["disabled"]
const _hoisted_20 = { class: "buttons" }
const _hoisted_21 = {
  key: 1,
  class: "spinner"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (!$setup.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h2", _hoisted_2, _toDisplayString($setup.isCreatePage ? "Add a user" : "Edit user"), 1),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("form", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _cache[9] || (_cache[9] = _createElementVNode("label", { class: "label" }, "First Name", -1)),
                _withDirectives(_createElementVNode("input", {
                  class: _normalizeClass(["input", { error: $setup.v$.form.firstName.$error }]),
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.form.firstName) = $event)),
                  type: "text",
                  placeholder: "First name"
                }, null, 2), [
                  [_vModelText, $setup.form.firstName]
                ]),
                ($setup.v$.form.firstName.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString($setup.v$.form.firstName.$errors[0].$message), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _cache[10] || (_cache[10] = _createElementVNode("label", { class: "label" }, "Last Name", -1)),
                _withDirectives(_createElementVNode("input", {
                  class: _normalizeClass(["input", { error: $setup.v$.form.lastName.$error }]),
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.form.lastName) = $event)),
                  type: "text",
                  placeholder: "Last Name"
                }, null, 2), [
                  [_vModelText, $setup.form.lastName]
                ]),
                ($setup.v$.form.lastName.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString($setup.v$.form.lastName.$errors[0].$message), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _cache[11] || (_cache[11] = _createElementVNode("label", { class: "label" }, "Email", -1)),
                _withDirectives(_createElementVNode("input", {
                  class: _normalizeClass(["input", { error: $setup.v$.form.email.$error }]),
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.form.email) = $event)),
                  type: "email",
                  placeholder: "Email"
                }, null, 2), [
                  [_vModelText, $setup.form.email]
                ]),
                ($setup.v$.form.email.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString($setup.v$.form.email.$errors[0].$message), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _cache[12] || (_cache[12] = _createElementVNode("label", { class: "label" }, "Phone", -1)),
                _createVNode($setup["Cleave"], {
                  class: _normalizeClass(["input", { error: $setup.v$.form.phone.$error }]),
                  modelValue: $setup.form.phone,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.form.phone) = $event)),
                  options: $setup.phoneNumberOption($setup.form.phone),
                  type: "text",
                  placeholder: "Phone"
                }, null, 8, ["modelValue", "options", "class"]),
                ($setup.v$.form.phone.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, "Invalid phone"))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _cache[13] || (_cache[13] = _createElementVNode("div", { class: "title-wrap" }, [
              _createElementVNode("div", { class: "card-title-bold" }, "Projects"),
              _createElementVNode("div", { class: "subtitle-main" }, "Select which projects this user will have access to")
            ], -1)),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.selectedProjects, (item, idx) => {
                  return (_openBlock(), _createElementBlock("button", {
                    class: "button default cancel-item-btn",
                    key: idx
                  }, [
                    _createElementVNode("img", {
                      src: _imports_0,
                      onClick: ($event: any) => ($setup.removeProject(item._id))
                    }, null, 8, _hoisted_18),
                    _createTextVNode(_toDisplayString(item.title), 1)
                  ]))
                }), 128)),
                _createElementVNode("button", {
                  class: "button default primary select-project",
                  disabled: !$setup.selectProjectsBtnAvailable,
                  onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.selectProjects()))
                }, "Select project(s)", 8, _hoisted_19)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("button", {
              class: "button default primary",
              onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.save()))
            }, "Save Changes"),
            _createVNode(_component_router_link, {
              class: "button default cancel",
              to: { name: 'LandownerUsers' }
            }, {
              default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                _createTextVNode("Cancel", -1)
              ]))]),
              _: 1
            })
          ])
        ]),
        _createVNode($setup["SelectProjectsModal"], {
          isOpen: $setup.showSelectProjectsModal,
          projects: $setup.projects,
          onSelectEstates: _cache[6] || (_cache[6] = ($event: any) => ($setup.setSelectProjects())),
          onSearchEstates: _cache[7] || (_cache[7] = ($event: any) => ($setup.getSearchQueryProjects($event))),
          onClose: _cache[8] || (_cache[8] = ($event: any) => ($setup.showSelectProjectsModal = false))
        }, null, 8, ["isOpen", "projects"])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_21))
}